export function changeDay(day) {
  const dayMap = {
    // Days of week
    Понедјељак: "monday",
    Понедељак: "monday",
    Уторак: "tuesday",
    Сриједа: "wednesday",
    Среда: "wednesday",
    Четвртак: "thursday",
    Петак: "friday",
    Субота: "saturday",
    Недјеља: "sunday",
    Недеља: "sunday",
    // Shifts
    "Прва смјена": "first_shift",
    "Прва смена": "first_shift",
    "1. смјена": "first_shift",
    "1. смена": "first_shift",
    "1-smena": "first_shift",
    "Друга смјена": "second_shift",
    "Друга смена": "second_shift",
    "2. смјена": "second_shift",
    "2. смена": "second_shift",
    "2-smena": "second_shift",
    "Трећа смјена": "third_shift",
    "Трећа смена": "third_shift",
    "3. смјена": "third_shift",
    "3. смена": "third_shift",
    "3-smena": "third_shift",
  };
  return dayMap[day];
}

export function convertNameOfDay(name) {
  // English to Serbian (nominative)
  const days = {
    Sunday: "Недјеља",
    Monday: "Понедјељак",
    Tuesday: "Уторак",
    Wednesday: "Сриједа",
    Thursday: "Четвртак",
    Friday: "Петак",
    Saturday: "Субота",
  };
  return days[name] || "";
}

export function switchDay(dani) {
  // Numeric to Serbian (genitive)
  const days = {
    1: "Понедељка",
    2: "Уторка",
    3: "Среде",
    4: "Четвртка",
    5: "Петка",
    6: "Суботе",
    7: "Недеље",
  };
  return days[dani] || "";
}
